// Status configuration constants
export const STATUS_COLORS = [
  "#ef4444", // red
  "#f59e0b", // yellow
  "#10b981", // green
  "#8b5cf6", // purple
  "#06b6d4", // cyan
  "#f97316", // orange
];

export const STATUS_VARIANTS = [
  "danger",
  "warning",
  "success",
  "primary",
  "info",
];

export const STATUS_ICONS = [
  "IconCheck",
  "IconDatabaseCog",
  "IconAlertTriangle",
  "IconSettings",
  "IconInfoCircle",
  "IconClock",
];

// Status utility functions
export const getStatusConfig = (statusId, statuses) => {
  if (!statuses || !statusId) {
    return {
      label: "Unknown",
      variant: "secondary",
      color: "#6b7280",
      icon: "IconAlertTriangleOff",
    };
  }

  const status = statuses.find((s) => String(s.id) === String(statusId));
  if (status) {
    const statusIndex = statuses.findIndex(
      (s) => String(s.id) === String(statusId)
    );

    return {
      label: status.name,
      variant: STATUS_VARIANTS[statusIndex % STATUS_VARIANTS.length],
      color: STATUS_COLORS[statusIndex % STATUS_COLORS.length],
      bgColor: `${STATUS_COLORS[statusIndex % STATUS_COLORS.length]}20`,
      icon: STATUS_ICONS[statusIndex % STATUS_ICONS.length],
    };
  }

  return {
    label: "Unknown",
    variant: "secondary",
    color: "#6b7280",
    bgColor: "#6b728020",
    icon: "IconAlertTriangleOff",
  };
};

export const getStatusConfigById = (statusId, statuses) => {
  if (statusId === "all") {
    return { label: "All Vehicles", color: "#6b7280" };
  }

  const status = statuses.find((s) => String(s.id) === statusId);
  if (status) {
    const statusIndex = statuses.findIndex((s) => String(s.id) === statusId);
    return {
      label: status.name,
      color: STATUS_COLORS[statusIndex % STATUS_COLORS.length],
    };
  }

  return { label: "Unknown Status", color: "#6b7280" };
};
